<template>
  <div id="auth" class="container flex flex-col min-h-screen">
    <div class="px-6 py-8">
      <img
        src="@/assets/img/logo.svg"
        alt="logo oab diario"
        class="w-32 lg:w-48 mx-auto pb-8"
      />

      <div class="flex-1">
        <h2 class="text-2xl font-medium text-center">
          <slot name="title" class="text-red-400" />
        </h2>
        <ValidationErrors
          :errors="validationErrors"
          v-if="validationErrors"
        ></ValidationErrors>

        <slot />
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import ValidationErrors from "../components/ValidationErrors";
export default {
  name: "LayoutAuth",
  components: { ValidationErrors },
  props: ["validationErrors"]
};
</script>
